<div class="ap-toggle">
    <mat-checkbox
        [disableRipple]="true"
        color="primary"
        [checked]="value"
        [disabled]="disabled"
        (change)="onChange($event)">
        <span class="ap-toggle-label">{{ section.label }}</span>
    </mat-checkbox>
    <p class="ap-toggle-description" *ngIf="section.description">{{ section.description }}</p>
</div>
